import React, { FC, useEffect, useState } from 'react';

import { Checkbox } from '@rbilabs/components-library/build/components/checkbox';
import { NumberInput } from '@rbilabs/components-library/build/components/number-input';

import { ProductListItem } from 'components/product-list-item';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { AddExtraItemControlType, IAddExtrasContentItemProps } from './types';

const AddExtrasContentItem: FC<IAddExtrasContentItemProps> = ({
  itemCalories,
  itemImage,
  itemName,
  index,
  isInCart,
  onChange,
  itemPrice,
  max,
  maxAmount,
}) => {
  const [checked, setChecked] = useState(false);

  const hideUiCalories = useFlag(LaunchDarklyFlag.HIDE_UI_CALORIES);
  const itemControl =
    maxAmount > 1 || !maxAmount
      ? AddExtraItemControlType.NUMBER_INPUT
      : AddExtraItemControlType.CHECKBOX;

  const handleCheckbox = (e: { target: { checked: boolean } }) => {
    const isItemChecked = e.target.checked ? 1 : 0;
    onChange(isItemChecked);
    setChecked(prevState => !prevState);
  };

  useEffect(() => {
    if (itemControl === AddExtraItemControlType.CHECKBOX && isInCart) {
      setChecked(isInCart);
    }
  }, [isInCart, itemControl, maxAmount]);

  const image = itemImage ? JSON.stringify(itemImage) : null;
  return (
    <ProductListItem
      controls={
        itemControl === AddExtraItemControlType.NUMBER_INPUT ? (
          <NumberInput
            hideNumberInput
            displayedValue={String(index)}
            value={index}
            onChange={onChange}
            max={max}
            aria-label={itemName}
            decrement-aria-label={`decrement-${itemName}`}
            increment-aria-label={`increment-${itemName}`}
            data-testid="extra-content-item-number-input"
          />
        ) : (
          <Checkbox
            label=""
            checked={checked}
            onChange={handleCheckbox}
            name={`checkbox-${itemName}`}
            aria-label={`checkbox-${itemName}`}
            data-testid="extra-content-item-checkbox"
          />
        )
      }
      productProps={{
        calories: !hideUiCalories ? itemCalories : undefined,
        image,
        name: itemName,
        price: itemPrice,
      }}
    />
  );
};

export default AddExtrasContentItem;
